"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 99939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ detailPrice; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./framework/ui/mobile/popup/index.ts + 3 modules
var popup = __webpack_require__(62835);
// EXTERNAL MODULE: ./framework/ui/mobile/text/index.ts + 2 modules
var mobile_text = __webpack_require__(6671);
// EXTERNAL MODULE: ./framework/ui/mobile/layout/index.tsx + 2 modules
var layout = __webpack_require__(48418);
// EXTERNAL MODULE: ./framework/ui/mobile/list/BulletListItem.tsx
var BulletListItem = __webpack_require__(93242);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@yb/styled-px2rem/esm/index.esm.js
var index_esm = __webpack_require__(53842);
// EXTERNAL MODULE: ./public/M/images/ico/ico_spr.png
var ico_spr = __webpack_require__(15042);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
;// CONCATENATED MODULE: ./components/style/detailpackage/pointM.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 0 15px 30px;\n	background: #fff;\n	text-align: left;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	margin-bottom: 30px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 30px 15px 15px;\n	font-size: 18px;\n	font-weight: bold;\n	color: var(--emp-color);\n	border-bottom: ",
        ";\n	span {\n		padding-left: 5px;\n		font-size: 14px;\n		font-weight: normal;\n		color: var(--default-color);\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	padding: 30px;\n	border: 1px solid var(--line-color);\n	li {\n		position: relative;\n		display: flex;\n		justify-content: space-between;\n		&::before {\n			position: absolute;\n			top: 50%;\n			left: -10px;\n			display: block;\n			width: 4px;\n			height: 4px;\n			border-radius: 50%;\n			background-color: var(--bl-color);\n			transform: translateY(-50%);\n			content: "";\n		}\n		span,\n		em {\n			font-weight: bold;\n		}\n		> span > em {\n			margin-right: 5px;\n		}\n	}\n	> li + li {\n		margin-top: 10px;\n	}\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding: 25px 15px;\n	&:not(:last-child) {\n		border-bottom: 1px solid var(--line-color);\n	}\n	> a {\n		display: flex;\n		flex-direction: column;\n		gap: 5px;\n		width: 100%;\n		height: 100%;\n		> dl {\n			display: flex;\n			align-items: center;\n			dt {\n				width: 45px;\n				color: var(--emp-color);\n			}\n		}\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 5px;\n	font-size: 15px;\n	color: var(--emp-color);\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	text-decoration: underline;\n	right: 15px;\n	bottom: 26px;\n	color: var(--emp-color);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	height: 100px;\n	font-size: 15px;\n	color: #828282;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 100%;\n	padding: 30px 15px;\n	background: #f3f3f3;\n	ul {\n		li {\n			word-break: keep-all;\n		}\n		li + li {\n			margin-top: 10px;\n		}\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	align-items: center;\n	line-height: 1;\n	margin-bottom: 10px;\n	font-size: 15px;\n	font-weight: bold;\n	color: var(--emp-color);\n	&::before {\n		display: inline-block;\n		width: 18px;\n		height: 20px;\n		background: url(",
        ') no-repeat 0 -118px;\n		background-size: 300px 300px;\n		vertical-align: middle;\n		content: "";\n	}\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	li {\n		font-size: 15px;\n		color: var(--default-color);\n	}\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: fit-content;\n	text-align: left;\n	text-decoration: underline;\n	",
        "\n\n	&:active, &:hover {\n		text-decoration: underline;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	text-align: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	height: 40px;\n	margin: 30px 0 37px;\n	background-color: var(--default-color);\n	color: #fff;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}



var CotentBox = index_esm/* default.div */.ZP.div(_templateObject());
var PromotionWrap = index_esm/* default.div */.ZP.div(_templateObject1());
var Title = index_esm/* default.h4 */.ZP.h4(_templateObject2(), function(props) {
    return props.line ? "1px solid var(--line-color)" : "";
});
var PointWrap = index_esm/* default.ul */.ZP.ul(_templateObject3());
var PromotionList = index_esm/* default.ul */.ZP.ul(_templateObject4());
var PromotionListItem = index_esm/* default.li */.ZP.li(_templateObject5());
var PromotionTitle = index_esm/* default.strong */.ZP.strong(_templateObject6(), (0,mobile_text/* Ellipsis */.mH)(1));
var LinkText = index_esm/* default.span */.ZP.span(_templateObject7());
var NoData = index_esm/* default.div */.ZP.div(_templateObject8());
var NotiBox = index_esm/* default.div */.ZP.div(_templateObject9());
var InfoTitle = index_esm/* default.h5 */.ZP.h5(_templateObject10(), (ico_spr_default()));
var BulletList = index_esm/* default.ul */.ZP.ul(_templateObject11());
var PromotionName = index_esm/* default.a */.ZP.a(_templateObject12(), (0,mobile_text/* Ellipsis */.mH)(2));
var TextAlign = index_esm/* default.div */.ZP.div(_templateObject13());
var InsuranceLink = index_esm/* default.a */.ZP.a(_templateObject14());


// EXTERNAL MODULE: ./framework/ui/mobile/table/index.tsx
var table = __webpack_require__(72186);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventMileage.ts
var useEventMileage = __webpack_require__(98846);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
;// CONCATENATED MODULE: ./components/product/common/popup/mobile/PointSavePop.tsx
















var PointSavePop = function(props) {
    var ref;
    var evCd = props.evCd, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "evCd"
    ]);
    var useEvtMileage = (0,useEventMileage/* default */.ZP)(evCd);
    var mileage = ((ref = useEvtMileage.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var adtMlgPoint = function(item) {
        var mlgPoint = item.mlgPoint;
        if (item.mlgSaveKindCd === "R1") {
            mlgPoint = Math.round((item.adtPrice + item.airtaxAdtCost + item.bafAdtCost) * item.mlgPoint / 100);
        }
        return mlgPoint;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        size: "full",
        title: "적립 예상 노랑풍선 포인트",
        padding: false,
        animate: "slideIn",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Area */.uN, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        children: [
                            "적립 예상 포인트",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "(예상 적립일자 2023 12월 31일)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CotentBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PointWrap, {
                            children: mileage && mileage.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                item.mlgGb,
                                                " (성인 1인 기준)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(mobile_text/* BlueText */.IW, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                    children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(adtMlgPoint(item))
                                                }),
                                                "P"
                                            ]
                                        })
                                    ]
                                }, index);
                            })
                        })
                    })
                ]
            }),
            mileage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PromotionWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        line: true,
                        children: "진행중인 프로모션"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* Table */.iA, {
                        types: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                children: "적립 예상 포인트 정보"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                        style: {
                                            width: "45%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                        style: {
                                            width: "22%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                        style: {
                                            width: "33%"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "col",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAlign, {
                                                    children: "프로모션"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "col",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAlign, {
                                                    children: "적립"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                scope: "col",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAlign, {
                                                    children: "기간"
                                                })
                                            })
                                        ]
                                    }),
                                    mileage.map(function(item, index) {
                                        var link = item.webBannerLink === "OUTLINK" ? item.bnrLink : "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/promotion/promotionDetail.yb?mstNo=").concat(item.bnrMstNo);
                                        return index !== 0 && item.mlgDivi === "MLG" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionName, {
                                                        href: link,
                                                        target: "_blank",
                                                        onClick: function(e) {
                                                            return (0,commonUtil/* onClickSSO */.Zy)(e, link);
                                                        },
                                                        children: item.promotionNm
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextAlign, {
                                                        children: [
                                                            item.mlgPoint,
                                                            item.mlgUnit
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextAlign, {
                                                        children: [
                                                            dayjs_min_default()(item.mlgStartDt).format("YYYY.MM.DD"),
                                                            "~",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            dayjs_min_default()(item.mlgEndDt).format("YYYY.MM.DD")
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, index);
                                    }),
                                    mileage.length === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            colSpan: 3,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAlign, {
                                                children: "진행중인 프로모션이 없습니다."
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotiBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitle, {
                        children: "유의 사항"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletList, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "만 14세 이상 노랑풍선 회원만 적립 가능합니다. (여행객 개별 적립)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "포인트는 온라인 회원가입(포인트 동의 포함) 후 실제 여행을 다녀오신 여행자를 대상으로 개별 적립됩니다. (만 14세 미만 포인트 적립 불가)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "여행상품 구매 및 여행 완료 후 결제금액의 1% 포인트를 적립해드립니다. (1포인트 =1원)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "결제 시 포인트로 사용한 금액 및 할인을 제외한 나머지 금액에 대하여 포인트를 적립해드립니다."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletListItem/* default */.Z, {
                                children: [
                                    "여행 완료 후 한국 도착일 기준 7일째 되는 날 자정에 자동 적립됩니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " 예) 2023년 1월 1일 도착(귀국)했을 경우 → 1월 7일까지 회원가입 완료 및 내 예약 찾기/매핑 완료 → 1월 8일 00시 자동 적립"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletListItem/* default */.Z, {
                                children: [
                                    "비회원의 경우 자동적립일 기준일 이전에 회원가입 후 별도 적립됩니다.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "(적립 기준일 이후에는 포인트 적립 불가)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "프로모션 / 이벤트에 따라 정책 및 적립 기준일 상이해, 프로모션 정책이 포인트 정책보다 우선 적용될 수 있습니다."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "적립 가능 상품 : 적립 불가 상품을 제외한 국내/외 여행 상품"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "적립 불가 상품 : 자유여행(항공권/호텔/액티비티/KTX/렌터카 등), 패키지여행(단품, 특가상품), 홈쇼핑/일반 제휴/ 소셜 커머스 상품, 그 외 노랑풍선 지정 일부 상품"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletListItem/* default */.Z, {
                                children: [
                                    "포인트 결제 가능 : 국내/해외 여행상품, 실시간 해외 항공권(일부 불가 조건 아래 참고),",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "실시간 호텔, 액티비티, KTX, 렌터카"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "포인트 결제 불가 : 실시간 항공권, 외부 채널 상품(제휴 채널, 홈쇼핑 등), 그 외 노랑풍선 지정 일부 상품"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                                children: "추가 적립 프로모션은 중복으로 적용되지 않으며, 가장 큰 혜택을 제공하는 1개 프로모션 기준으로 적립됩니다."
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var mobile_PointSavePop = (/*#__PURE__*/(0,react.memo)(PointSavePop));

// EXTERNAL MODULE: ./components/style/detailpackage/itineraryM.tsx
var itineraryM = __webpack_require__(50341);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPrice.ts
var useEventPrice = __webpack_require__(8745);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/mobile/detailPrice/index.tsx

















var DetailPriceComponent = function(props) {
    var ref, ref1;
    var event = props.eventDetail, query = props.query, _usePointBtn = props.usePointBtn, usePointBtn = _usePointBtn === void 0 ? true : _usePointBtn;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref2[0];
    var eventPriceFetch = (0,useEventPrice/* default */.ZP)(query.evCd);
    var eventPrice = (ref = eventPriceFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var useEvtMileage = (0,useEventMileage/* default */.ZP)(query.evCd);
    var mileage = ((ref1 = useEvtMileage.data) === null || ref1 === void 0 ? void 0 : ref1.body) || [];
    var price = (0,eventUtil/* getPrice */.aS)(eventPrice);
    var TdPrice = function(param) {
        var _type = param.type, type = _type === void 0 ? "adult" : _type;
        var amount = {
            adult: {
                price: price.adult,
                baf: eventPrice.bafAdtCost,
                air: eventPrice.airTaxAdtCost
            },
            child: {
                price: price.child,
                baf: eventPrice.bafChdCost,
                air: eventPrice.airTaxChdCost
            },
            infant: {
                price: price.infant,
                baf: eventPrice.bafInfCost,
                air: eventPrice.airTaxInfCost
            }
        };
        var cost = amount[type];
        var isFH = (0,eventUtil/* isGoodsTpFH */.mk)(event.goodsTp);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !isFH ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* TablePriceBox */.WW, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: price && ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(cost.price)
                                }),
                                "원"
                            ]
                        }),
                        (cost.baf > 0 || cost.air > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "세금 및 유류할증료 ".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(cost.baf + cost.air), "원 포함")
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: cost.price > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* TablePriceBox */.WW, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: price && ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(cost.price)
                                }),
                                "원"
                            ]
                        }),
                        (cost.baf > 0 || cost.air > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "세금 및 유류할증료 ".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(cost.baf + cost.air), "원 포함")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* TablePriceBox */.WW, {
                    children: "별도문의"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Area */.uN, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* TitleWrap */.BV, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_text/* SubTitle */.DK, {
                        children: "상품가"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* SubText */.i_, {
                        children: event.fixRervCd !== "YT" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "(예약금)",
                                " ",
                                eventPrice.depositAmt === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "별도안내"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "".concat(eventPrice.depositDivi ? eventPrice.depositDiviNm : "", " ").concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(eventPrice.depositAmt), "원")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* PriceTable */.Kv, {
                types: "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                        children: "여행지 안전 정보 안내"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: "33.333%"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: "33.333%"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: "33.333%"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* AgeLimitBox */.lD, {
                                        children: [
                                            "성인",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* AgeLimit */.NP, {
                                                children: "(만12세 이상)"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* AgeLimitBox */.lD, {
                                        children: [
                                            "아동",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* AgeLimit */.NP, {
                                                children: "(만2세~만12세 미만)"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* AgeLimitBox */.lD, {
                                        children: [
                                            "유아",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* AgeLimit */.NP, {
                                                children: "(만2세 미만)"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                price && /*#__PURE__*/ (0,jsx_runtime.jsx)(TdPrice, {}),
                                price && /*#__PURE__*/ (0,jsx_runtime.jsx)(TdPrice, {
                                    type: "child"
                                }),
                                price && /*#__PURE__*/ (0,jsx_runtime.jsx)(TdPrice, {
                                    type: "infant"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* Point */.LP, {
                children: usePointBtn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(itineraryM/* TitleTextBox */.ZU, {
                    href: "#",
                    target: "_blank",
                    onClick: function(e) {
                        e.preventDefault();
                        open(function(overlay) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_PointSavePop, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
                                evCd: query.evCd
                            }));
                        });
                    },
                    children: [
                        "(성인1인기준) ",
                        mileage && ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber((0,goodsUtil/* getExpectMileage */.bd)(mileage)),
                        " P 적립예정",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* PopupButton */.cy, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "포인트 적립 팝업으로 이동"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(itineraryM/* BulletBox */.vt, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletListItem/* default */.Z, {
                        children: "유류할증료 및 TAX는 유가 및 환율 등에 따라 변동될 수 있으며, 아동/유아 기준은 항공사 마다 상이하여 예약 후 최종 확정됩니다."
                    })
                })
            })
        ]
    });
};
var DetailPrice = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventDetailPrice Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailPriceComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailPrice = (/*#__PURE__*/(0,react.memo)(DetailPrice));


/***/ }),

/***/ 98846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports eventMileageAsync, eventMileageSSR, getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventMileage";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/expect-mileage");
};
/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventMileageAsync = function(evCd) {
    return useConfigureAxios(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventMileageSSR = function(evCd) {
    return useConfigureAxios(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventMileage = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventMileage);



/***/ })

}]);